import React, { useState } from 'react';
import clsx from 'clsx';

import './index.scss';

const PulldownInput = ({ items, selectedValue, onChange, isOpen = false, inValid = false }) => {
  const [ open ] = useState(isOpen);
  
  const selectedItem = items.filter(item => item.value === selectedValue)[0];
  const noSelect = !selectedItem;

  return (
    <div
      className={clsx(
        'PulldownInput',
        { many: items.length > 5 },
        { open },
        { noSelect },
      )}
    >
      <select onChange={onChange} className={clsx({ inValid })}>
        <option value="" hidden selected={noSelect}>選択</option>
        {items.map((item) => {
          const selected = noSelect ? !noSelect : selectedItem.value === item.value ;
          return (
            <option 
              value={item.value}
              selected={selected}
              key={item.value}
            >
              {item.label}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default PulldownInput;